import {getStatusCell, renderFormField} from '@common'
import {ContractStatus, TranslationKey} from '@enums'
import {Grid, Stack} from '@mui/material'

import React from 'react'

import {UIKit} from '@components'

import {useContractLegacyViewModel} from './contract-legacy-view-model'
import {Label} from './style'

/**
 * Contract Legacy View page
 */
export function ContractLegacyViewPage() {
  const {contractOverviewFormFields, contractPricingFormFields, productColumns, productRows, contractStatus, t} =
    useContractLegacyViewModel()

  return (
    <>
      <UIKit.BackgroundCard title={t(TranslationKey['Contract'])}>
        <Grid container spacing={2}>
          <Grid item sm={4}>
            <Stack style={{alignItems: 'flex-start', gap: '0.5rem'}}>
              <Label>{t(TranslationKey.Status)}</Label>
              <Stack style={{width: 150}}>{contractStatus && getStatusCell(t, contractStatus as ContractStatus)}</Stack>
            </Stack>
          </Grid>
          {contractOverviewFormFields.map((item, index) => (
            <Grid key={`contract-overview-form-field-${index}`} item sm={4}>
              {renderFormField(item)}
            </Grid>
          ))}
        </Grid>
      </UIKit.BackgroundCard>

      <UIKit.BackgroundCard>
        <Grid container spacing={2}>
          {contractPricingFormFields.map((item, index) => (
            <Grid key={`contract-pricing-form-field-${index}`} item sm={4}>
              {renderFormField(item)}
            </Grid>
          ))}
        </Grid>
      </UIKit.BackgroundCard>

      <UIKit.BackgroundCard>
        <UIKit.Table
          columns={productColumns}
          rows={productRows}
          title={t(TranslationKey.Products)}
          hidePagination
          hideSearch
          hideToolbar
        />
      </UIKit.BackgroundCard>
    </>
  )
}
